/**
 * Import SASS dependencies
 */
import '../sass/main.scss';

/**
 * Import module dependencies
 */
import $ from "jquery";
import 'bootstrap';

import './components/hamburg.es6';
import './components/style-attributes.es6';
import './vendors-extensions/headroom.es6';

( ( $ ) => {

    $( '#hamburgNavigation > ul > li' ).hamburg();

    $( '.has-attribute-styles').style_attributes();

} )( $.noConflict() )